import { Navigate, Route, Routes } from 'react-router-dom';

import { loginRedirectPath } from '@/utils/loginRedirect';

import { Login } from './Login/Login';
import { ResetPasswordContainer } from './ResetPassword/ResetPasswordContainer';
import { ResetPasswordRequestContainer } from './ResetPasswordRequest/ResetPasswordRequestContainer';
import { UserRegisterContainer } from './UserRegister/UserRegisterContainer';

function Public() {
    return (
        <Routes>
            {/* The "2" paths are the old names of the same pages; links to them still work. */}
            <Route path="/login" element={<Login />} />
            <Route path="/login2" element={<Login />} />
            <Route path="/reset-password-request" element={<ResetPasswordRequestContainer />} />
            <Route path="/reset-password-request2" element={<ResetPasswordRequestContainer />} />
            <Route path="/reset-password" element={<ResetPasswordContainer />} />
            <Route path="/reset-password2" element={<ResetPasswordContainer />} />
            <Route path="/register" element={<UserRegisterContainer />} />
            <Route
                path="*"
                element={<Navigate to={loginRedirectPath(window.location.href)} replace />}
            />
        </Routes>
    );
}

export default Public;
